import React from 'react'

export const DashboardSkeleton = () => {
    return (
        <div className="animate-pulse">
            {/* Stats Cards Skeleton */}
            <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4 mb-6">
                {[...Array(12)].map((_, i) => (
                    <div
                        key={i}
                        className="bgwhite p-4 rounded-lg shadow-lg border border-gray-100 flex items-center justify-between"
                    >
                        <div className="w-full">
                            <div className="h-4 bg-gray-200 rounded w-2/3 mb-2"></div>
                            <div className="h-5 bg-gray-200 rounded w-1/3"></div>
                        </div>
                        <div className="w-10 h-10 bg-gray-200 rounded-xl ml-4"></div>
                    </div>
                ))}
            </div>

            {/* Charts Row */}
            <div className="flex flex-col lg:flex-row gap-4">
                {/* Revenue by Station Chart Skeleton */}
                <div className="bgwhite p-4 rounded-xl shadow-lg border border-gray-100 w-full lg:w-[60%] pb-0">
                    <div className="h-6 bg-gray-200 rounded w-1/4 mb-4"></div>
                    <div className="h-[250px] bg-gray-200 rounded"></div>
                </div>
                {/* Payment Methods Skeleton */}
                <div className="bgwhite p-4 rounded-xl shadow-lg border border-gray-100 w-full lg:w-[40%]">
                    <div className="h-6 bg-gray-200 rounded w-1/4 mb-4"></div>
                    <div className="h-[230px] bg-gray-200 rounded"></div>
                </div>
            </div>

            {/* Revenue by Routes and Overview Skeleton */}
            <div className="flex flex-col lg:flex-row gap-4 mt-6">
                {/* Revenue by Routes Skeleton */}
                <div className="bgwhite p-4 rounded-xl shadow-lg border border-gray-100 w-full lg:w-[55%]">
                    <div className="h-6 bg-gray-200 rounded w-1/3 mb-4"></div>
                    <div className="space-y-4">
                        {[...Array(5)].map((_, i) => (
                            <div key={i} className="h-12 bg-gray-200 rounded"></div>
                        ))}
                    </div>
                </div>
                {/* Revenue Overview Skeleton (Captains & Boats) */}
                <div className="bgwhite p-4 rounded-xl shadow-lg border border-gray-100 w-full lg:w-[45%]">
                    <div className="h-6 bg-gray-200 rounded w-1/2 mb-4"></div>
                    <div className="min-w-[600px] lg:min-w-full">
                        <div className="space-y-4 mb-8">
                            {[...Array(3)].map((_, i) => (
                                <div key={i} className="h-10 bg-gray-200 rounded"></div>
                            ))}
                        </div>
                    </div>
                    <div className="h-6 bg-gray-200 rounded w-1/2 mb-4"></div>
                    <div className="min-w-[600px] lg:min-w-full">
                        <div className="space-y-4">
                            {[...Array(3)].map((_, i) => (
                                <div key={i} className="h-10 bg-gray-200 rounded"></div>
                            ))}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}
